<template>
  <div class="errorPage">
    <p id="message">ログインの有効期間が切れました。</p>
    <el-button type="primary" @click="onReLogin" size="medium">再ログイン</el-button>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  data() {
    return {
      form: {
      },
    }
  },
  methods: {
    onReLogin() {
      location.href='/';
    },
  },
}
</script>

<style scoped>
  p#message {
    font-size: 14pt;
  }
</style>
